// Interactive pieces of the Resi Setup module, shown inside the standard Training page layout.
import React, { useEffect, useState } from 'react';
import { ref, onValue, set, remove } from 'firebase/database';
import { database } from '../../firebaseConfig';
import { useNavigate } from 'react-router-dom';
import ConnectYourAI from '../ConnectYourAI';
import { useAuth } from '../../context/AuthContext';
import { PROFILE_GUIDE, PROFILE_CHECKLIST } from '../../data/resiSetupProfileGuide';
import { replayTutorial } from '../../config/tutorialSteps';

const p = { fontSize: 17, lineHeight: 1.6, margin: '0 0 12px' };
const btn = { backgroundColor: '#D4AF37', color: '#000', border: 'none', borderRadius: 6, padding: '10px 20px', cursor: 'pointer', fontWeight: 700, fontSize: 15, fontFamily: 'inherit' };
const ghost = { ...btn, backgroundColor: 'transparent', border: '1px solid #1a1a1a', fontWeight: 600 };
const label = { fontSize: 12, fontWeight: 700, letterSpacing: '0.5px', textTransform: 'uppercase', color: '#8C6D1F', margin: '18px 0 8px' };

export function SetupActions() {
  const navigate = useNavigate();
  return (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', margin: '8px 0 4px' }}>
      <button type="button" onClick={() => navigate('/profile')} style={btn}>Open my profile</button>
      <button type="button" onClick={replayTutorial} style={ghost}>Replay the Resi tour</button>
    </div>
  );
}

// Saves each ticked item for the signed-in agent so the list is still ticked when they come back.
const checklistKey = (name) => name.replace(/[.#$/[\]]/g, '_');

export function ProfileChecklistStep() {
  const { user } = useAuth();
  const uid = user?.uid;
  const [checked, setChecked] = useState({});
  useEffect(() => {
    if (!uid) return undefined;
    return onValue(ref(database, `users/${uid}/trainingChecklists/resiSetupProfile`), (s) => setChecked(s.val() || {}));
  }, [uid]);
  const toggle = (name, on) => {
    if (!uid) return;
    const r = ref(database, `users/${uid}/trainingChecklists/resiSetupProfile/${checklistKey(name)}`);
    (on ? set(r, true) : remove(r)).catch((err) => console.error('Checklist save failed:', err));
  };
  return (
    <div style={{ background: '#fbf7ee', border: '1px solid #e5d6b0', borderRadius: 8, padding: '12px 16px', margin: '4px 0 16px' }}>
      <div style={{ ...label, marginTop: 0 }}>Gather this before you start</div>
      <ul style={{ paddingLeft: 0, margin: 0, listStyle: 'none' }}>
        {PROFILE_CHECKLIST.map((f) => (
          <li key={f.name} style={{ fontSize: 15, lineHeight: 1.55, marginBottom: 6 }}>
            <label style={{ cursor: 'pointer' }}><input type="checkbox" checked={!!checked[checklistKey(f.name)]} onChange={(e) => toggle(f.name, e.target.checked)} style={{ marginRight: 8 }} /><strong>{f.name}</strong>{f.who !== 'Everyone' ? ` (${f.who})` : ''}: {f.where}</label>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function ProfileGuideStep() {
  const navigate = useNavigate();
  return (
    <div>
      {PROFILE_GUIDE.map((g) => (
        <div key={g.group}>
          <div style={label}>{g.group}</div>
          {g.fields.map((f) => (
            <div key={f.name} style={{ borderLeft: '3px solid #D4AF37', padding: '4px 0 4px 12px', marginBottom: 14 }}>
              <div style={{ fontSize: 17, fontWeight: 700 }}>{f.name}{f.who ? <span style={{ color: '#7f7f7f', fontSize: 13, fontWeight: 400 }}> · {f.who}</span> : null}</div>
              <div style={{ ...p, margin: '2px 0' }}><em>What it is:</em> {f.what}</div>
              <div style={{ ...p, margin: '2px 0' }}><em>Why it matters:</em> {f.why}</div>
              <div style={{ ...p, margin: '2px 0' }}><em>How to fill it in:</em> {f.how}</div>
              <div style={{ ...p, margin: '2px 0' }}><em>Where to get it:</em> {f.where}</div>
            </div>
          ))}
        </div>
      ))}
      <button type="button" onClick={() => navigate('/profile')} style={btn}>Open my profile</button>
    </div>
  );
}

export function ConnectAIStep() {
  const { user, userRole } = useAuth();
  return user?.uid ? <ConnectYourAI isSelf isAdmin={userRole === 'Admin'} /> : null;
}
